<div class="rm-header">
  <span>Initiate Subscription Document</span>
</div>
<mat-dialog-content *ngIf="pageStatus == PageStatus.EDITING">
  <!--    EDITING-->
  <p>
    You can initiate Subscription documents from this page, please follow the instructions below to generate your SubDoc.
  </p>

  <form [formGroup]="fg">

    <div style="display: flex; flex-direction: column; gap: 25px !important;">
      <!-- ROW START -->
      
      <div class="row">
        <div class="align-center">
          <mat-icon>looks_one</mat-icon><span>Indicate the amount of subscription in single unit US Dollars, ie. 5000000 for $5 Million USD</span>
        </div>
        <div class="col-6">
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Amount of Subscription</mat-label>
            <input matInput id="amount" type="number" readonly
                    formControlName="amount"
                    required/>
            <mat-hint align="end">The amount of subscription should be in single unit US Dollars</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <!-- ROW START -->
      <div class="row">
        <div class="align-center">
          <mat-icon>looks_two</mat-icon><span>Select the Legal Entity that you want to invest through (Investing Entity must have an approved KYC)</span>
        </div>

        <div class="col-6">
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Entity to Invest</mat-label>
            <mat-select required [(ngModel)]="selectedBusinessUnitEntity" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let entity of businessUnitEntities" [value]="entity">
                {{ entity.entityName }} - with {{entity.kycSignatories.length}} KYC Approved Signer(s)
              </mat-option>
            </mat-select>
            <mat-hint align="end">Please select the Entity through which you will to invest.</mat-hint>
          </mat-form-field>
          <mat-error *ngIf="selectedBusinessUnitEntity?.kycErrorMessage">{{ selectedBusinessUnitEntity?.kycErrorMessage }}</mat-error>
        </div>
      </div>

      <!-- ROW START -->
      <div class="row" *ngIf="!!businessUnitEntities?.length && !!selectedBusinessUnitEntity && !selectedBusinessUnitEntity.kycErrorMessage">
        <div class="align-center">
          <mat-icon>looks_3</mat-icon><span>Select the signer(s) that you have set in your Approved KYC</span>
        </div>
        <p>
          The list of signers below are extracted from the KYC authorized signatories liked to the
          Investing Entity selected above.  Please select each signer from the list and click <b>"Add Sub Doc Signer"</b> to add the signer to the list.
          <br /><br />
          <em>If you want to add a new signer, <a class="link" role="button" (click)="addNonKYCSignatory()">click here</a>.</em>
        </p>
        <div class="row">
          <div class="col-6">
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Signer(s)</mat-label>
              <mat-select required [(ngModel)]="selectedSignatory" [ngModelOptions]="{standalone: true}"
                [disabled]="!selectedBusinessUnitEntity || selectedBusinessUnitEntity.kycSignatories.length == 0"
              >
                <mat-option *ngFor="let signatory of selectedBusinessUnitEntity?.kycSignatories" [value]="signatory">
                  {{ signatory.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-4">
            <div style="padding-top: 7px;">
               <button mat-raised-button [disabled]="!selectedSignatory"
                    (click)="addSelectedSignatory()" color="primary">Add Sub Doc Signer</button>
            </div>
          </div>
        </div>

      </div>

      <!-- ROW START -->
      <div class="row">
        <div class="col-12">
          <table class="table">
            <thead>
            <tr>
              <th class="form-table-header" colspan="4">Subscription Docs Users (Order of Signers is Important)</th>
            </tr>
            <tr>
              <th class="form-table-header">Signers</th>
              <th class="form-table-header">Email Address</th>
              <th class="form-table-header">Signing Order</th>
              <th class="form-table-header center">Actions</th>
            </tr>
            </thead>
            <tbody>
              <tr *ngFor="let signatory of dealSignatories; index as i;">
                <td>
                  {{signatory.fullName}}<br />
                  <em style="font-size: smaller; color: blue;" *ngIf="!!signatory.businessUnitEntityKycPersonId">KYC Approved Signer</em>
                  <em style="font-size: smaller; color: orange;" *ngIf="!signatory.businessUnitEntityKycPersonId">Signer not KYC Approved</em>
                </td>
                <td>{{signatory.email}}</td>
                <td>{{ i + 1 }}</td>
                <td>
                  <button mat-icon-button type="button">
                    <mat-icon color="warn"
                              (click)="removeSignatory(signatory)"
                              title="Remove Signer"
                    >delete
                    </mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ROW START -->
      <div class="row">
        <div class="align-center">
          <mat-icon>looks_4</mat-icon><span>Affirm that your KYC is up to date</span>
        </div>
        <div class="col-12">
          <span>
            <b>By signing my full name in the textbox below, I affirm that all the information in the KYC forms is accurate and up to date.</b>
          </span>
          <br>
          <span *ngIf="!!selectedBusinessUnitEntity">
            You can access the KYC for your selected entity by <a (click)="openKyc()" class="link pointer">clicking here</a>
          </span>
        </div>
        <div class="col-6 pt-3">
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Please type your full name</mat-label>
            <input matInput id="auth"
                  type="text"
                  placeholder="e.g. John Smith"
                  required
                  formControlName="signOffPersonName"
            />
            <mat-hint align="end">Please type your full name</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>

</mat-dialog-content>
<mat-dialog-actions class="space-between" *ngIf="pageStatus == PageStatus.EDITING">
  <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
  <button mat-raised-button
        color="primary"
        type="button"
        (click)="initSubDoc()"
        [disabled]="fg.invalid || dealSignatories.length == 0 || dealSignatories.length > 2"
    > 
    Initiate Subscription Document
  </button>
</mat-dialog-actions>

<!--    COMPLETE-->
<mat-dialog-content *ngIf="pageStatus == PageStatus.COMPLETE">
  <!-- ROW START -->
  <div class="row" style="padding: 15px 12px;">
    <div class="col-12">
      <span class="rm-title-3">Sub Doc Successfully Created!</span><br/>
    </div>
  </div>
  <div class="row" style="padding: 15px 12px;">
    <div class="col-12">
      <span style="font-weight: bold;">Congratulations, Rondeivu is now preparing your subscription document!</span><br/>
    </div>
  </div>
  <div class="row" style="padding: 15px 12px;">
    <div class="col-12">
      <span>You will soon receive an email with instructions to add/edit details and approve a final draft.
        Signers will then receive an email notification when the document is ready for signature.</span>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="space-between" *ngIf="pageStatus == PageStatus.COMPLETE">
  <button mat-raised-button type="button" (click)="dialogRef.close(true)">CLOSE</button>
</mat-dialog-actions>
